var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background"},[_c('div',{staticClass:"panel"},[_c('GenericPrivacyVoodoo')],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('a',{staticClass:"TextContact",attrs:{"href":"mailto: contact@munmungames.com"}},[_vm._v("Contact")]),_c('a',{staticClass:"TextContact",attrs:{"href":"/"}},[_vm._v("Home")])])
}]

export { render, staticRenderFns }